// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"580afa850f407b1c9a15","293":"8fbe333ee74c0bea6b1c","518":"85b852f257e41f3712c5","779":"608515b4784637f2c036"}[chunkId] + ".js";
};